import React from 'react';
import { Box, Heading, HStack, Image, List, ListItem, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { SealButton } from './SealButton';
import { AnimatedCheck } from './AnimatedCheck';
import { Reveal } from './Reveal';
import { brand, images, whatsappHref } from '../data/brand';
const points = ['Conversamos contigo antes de iniciar cualquier práctica.', 'Te explicamos con claridad en qué consiste cada servicio.', 'Cada consulta se adapta a tu situación particular.'];
export function About() {
  return <Box as="section" id="nosotros" bg="cream.50" color="ink.900" position="relative" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 16,
    md: 24
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 4vw, 100% 0, 100% 100%, 0 100%)'
    }
  }} data-id="element-14" data-mp="3dgjd22lpzq2h">
      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} data-id="element-15" data-mp="3rgau6c7j9mkp">
        <SimpleGrid columns={{
        base: 1,
        lg: 2
      }} spacing={{
        base: 12,
        lg: 20
      }} alignItems="center" data-id="element-16" data-mp="3rh3uaubzldtv">
          <Reveal x={-24} y={16} data-id="element-17" data-mp="2lsihlt0mgpnq">
            <Box position="relative" maxW="34rem" data-id="element-18" data-mp="2gse0q1vsxswz">
              <Box position="absolute" top="-1.25rem" left="-1.25rem" right="1.5rem" bottom="1.5rem" bg="crimson.500" opacity={0.12} sx={{
              borderRadius: '62% 38% 46% 54% / 55% 45% 55% 45%'
            }} aria-hidden="true" data-id="element-19" data-mp="2gqkwet8nvks5" />
              <Image src={images.about} alt="Mesa de consulta con una vela encendida, cristales de amatista y hierbas secas" w="100%" maxH={{
              base: '24rem',
              lg: '34rem'
            }} objectFit="cover" position="relative" border="2px solid" borderColor="gold.400" sx={{
              borderRadius: '58% 42% 52% 48% / 48% 52% 48% 52%'
            }} data-id="element-20" data-mp="30fvbq64hw3pq" />
            </Box>
          </Reveal>

          <Reveal x={24} y={16} data-id="element-21" data-mp="66vcwxz9rn3z">
            <VStack align="flex-start" spacing={5} data-id="element-22" data-mp="67wz9ylqjw10">
              <HStack spacing={3} data-id="element-23" data-mp="b56md7lnjvlo">
                <Box w="2.5rem" h="1px" bg="crimson.500" data-id="element-24" data-mp="b459cxl2sz1b" />
                <Text fontSize="xs" fontWeight={700} letterSpacing="0.3em" textTransform="uppercase" color="crimson.500" data-id="element-25" data-mp="3tjpmpkrfx1lm">
                  Templo de Ayuda Esotérica
                </Text>
              </HStack>

              <Heading as="h2" fontSize={{
              base: '2rem',
              md: '3.1rem'
            }} color="ink.900" textTransform="uppercase" data-id="element-26" data-mp="3okmgvy3myrcl">
                Acerca de nosotros
              </Heading>

              <Text fontSize={{
              base: 'md',
              md: 'lg'
            }} color="ink.700" opacity={0.85} data-id="element-27" data-mp="18sp2j3hn7zzp">
                Contamos con experiencia en servicios y prácticas esotéricas tradicionales. Nuestro
                objetivo es ofrecer orientación personalizada y atención cercana a cada persona que
                nos consulta.
              </Text>

              <List spacing={4} pt={1} data-id="element-28" data-mp="2tc0zh8bjgqmt">
                {points.map((point, index) => <ListItem key={point} display="flex" alignItems="flex-start" gap={3} data-id="element-29" data-mp="373630li1232f" data-mpi={index}>
                    <AnimatedCheck delay={index * 0.18} data-id="element-30" data-mp="32b5wga7gcbwv" />
                    <Text fontSize="md" color="ink.700" data-id="element-31" data-mp="329l1wkl50sz0">
                      {point}
                    </Text>
                  </ListItem>)}
              </List>

              <Box alignSelf="center" pt={1} data-id="element-32" data-mp="3c0xuxfio9p6m">
                <SealButton href={whatsappHref('una consulta personalizada')} external tone="whatsapp" label="Consultar por WhatsApp" caption={brand.whatsapp} icon={<WhatsAppIcon size={17} data-id="element-34" data-mp="1vn7lrucp4aq4" />} data-id="element-33" data-mp="3q1idqbol7l04" />
              </Box>
            </VStack>
          </Reveal>
        </SimpleGrid>
      </Box>
    </Box>;
}